<template>
  <div>
    <Snackbar v-if="errorText!==''">{{ errorText }}</Snackbar>
    <!--    <vue-progress-bar></vue-progress-bar>-->
    <router-view></router-view>
    <MaskLoading v-if="showLoading"/>
  </div>
</template>

<script>
  import Snackbar from './components/Snackbar';
  import MaskLoading from "./components/MaskLoading";
  import {mapGetters} from "vuex";

  export default {
    name: "App",
    components: {
      Snackbar,
      MaskLoading
    },
    computed: {
      ...mapGetters(['showLoading', 'errorText'])
    },
    data() {
      return {};
    },
    methods: {},
    created() {

    }
  };
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .input {
    width: 100%;
    height: 30px;
    padding: 0 5px;
    background: no-repeat 0 0 scroll #fff;
    outline: medium;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .input:focus {
    border-color: #2196f3;
  }

  .select {
    height: 30px;
    border: 1px solid #ddd;
  }

  .bg {
    background: rgba(237, 237, 237, 1);
    min-height: 100vh;
  }

  .center {
    text-align: center;
  }

  button {
    outline: none;
    padding: 8px 16px;
    border-radius: 5px;
    border: none;
  }

  button[block] {
    width: 100%;
  }

  button.info {
    background: #2196f3 !important;
    color: #fff !important;
  }

  button.info.outline {
    background: #fff !important;
    color: #2196f3 !important;
    border: 1px solid #2196f3;
  }

  button[outline] {
    background: none;
  }

  button[disabled] {
    background: rgba(0, 0, 0, 0.12) !important;
    color: rgba(0, 0, 0, .26) !important
  }

  .mb-3 {
    margin-bottom: 15px;
  }
  .mb-2 {
    margin-bottom: 10px;
  }
  .wrapper {
    padding: 18px;
    font-size: 14px;
  }

  .info {
    color: #2196f3;
  }

  .warning {
    color: #F2A138;
  }

  .danger {
    color: #FF2900;
  }

  .success {
    color: #21B811;
  }

  .secondary {
    color: #ccc;
  }

  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mask .box {
    width: 251px;
    /*height:288px;*/
    background: #fff;
    border-radius: 10px;
  }

  /*负债表*/
  .xn-table{
    padding:0 12px;
    margin-bottom: 12px;
  }
  .xn-table table{
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    font-size: 13px;
  }
  .xn-table table thead{
    display: table;
    width:100%;
    background: #F5F5F5;
  }
  .xn-table table thead tr{
    border-bottom: none !important;
  }
  .xn-table table thead th{
    height: 40px;
    font-weight: normal;
    position: relative;
  }
  .xn-table table thead th:nth-child(1){
    width:10%;
  }
  .xn-table table thead th:nth-child(2){
    text-align: left;
  }
  .xn-table table thead th:nth-child(3),
  .xn-table table thead th:nth-child(4){
    text-align: right;
  }
  .xn-table table tbody{
    display: block;
    height: calc(100vh - 80px - 14px);
    width:100%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .xn-table thead th:nth-child(1)::before{
    content: '';
    display: block;
    height: 40px;
    width:12px;
    background: #F5F5F5;
    position: absolute;
    left:-12px;
    top:0;
  }
  .xn-table thead th:nth-child(4)::after,
  .xn-table thead th:nth-child(1)::after{
    content: '';
    display: block;
    height: 40px;
    width:12px;
    background: #F5F5F5;
    position: absolute;
    right:-12px;
    top:0;
  }

  .xn-table td {
    height: 40px;
    position: relative;
    padding:8px 0;
  }

  .xn-table tr td:nth-child(1) {
    width: 10%;
    text-align: center;
  }

  .xn-table tr td:nth-child(3),
  .xn-table tr td:nth-child(4) {
    /*width: 25%;*/
    text-align: right;
    color:#FD493A;
  }
  .xn-table tr{
    border-bottom: 1px solid #ccc;
  }
  .xn-table tr.no-border{
    border-bottom: none;
  }
  .xn-table tr.bold td:nth-child(2){
    font-weight: bold;
  }
</style>
